<template>
  <div
    id="recommend-risk"
    class="risk"
    :class="`${!score ? 'tw-h-[100%] tw-flex tw-flex-col' : ''}`"
  >
    <div
      id="recommend-title-risk"
      :class="`${
        typeStyle
          ? 'tw-p-[20px] tw-h-[56px] tw-bg-[#FCFCFD]'
          : 'tw-px-[20px] tw-pt-[20px] tw-pb-[10px] tw-h-[46px]'
      } tw-flex tw-items-center tw-justify-between`"
      :style="`border-bottom: ${typeStyle ? '1px solid #eff0f1' : 'none'}`"
    >
      <div class="!tw-text-[15px] tw-font-semibold tw-w-full tw-text-[#211F58]">
        <slot>
          {{ getComponentUiText("app-assess-recommendations-title-risk-1") }}
        </slot>
      </div>
    </div>
    <div v-if="isLoading" class="tw-flex tw-w-full tw-h-[134px]">
      <span class="custom-global-skeleton tw-w-full tw-h-full"></span>
    </div>
    <div v-else class="tw-h-full tw-relative">
      <div class="risk__content tw-z-1 tw-w-full tw-h-full">
        <div
          v-for="(item, index) in listRiskRef"
          :key="index"
          :class="`tw-px-[20px]  ${
            typeStyle ? 'tw-h-[48px] tw-py-[14px]' : 'tw-h-[69px] tw-py-[12px]'
          }  tw-flex-row tw-gap-[15px]`"
          :style="` ${
            index !== listRiskRef.length - 1
              ? 'border-bottom: 1px solid #eff0f1'
              : ''
          } `"
        >
          <div
            style="line-height: 20px"
            :class="`tw-flex tw-justify-between ${
              typeStyle ? '' : 'tw-pb-[12px]'
            }`"
          >
            <div
              class="tw-font-[500] tw-text-[#211F58] tw-h-[20px] tw-text-[12px]"
            >
              {{ item.text }}
            </div>
            <div
              class="tw-flex tw-h-[20px] tw-text-[10px] tw-gap-[15px] tw-font-[500]"
            >
              <div
                v-if="item.lowNumber || !item.isReduction"
                :class="`tw-flex tw-gap-[6px] tw-items-center ${
                  typeStyle ? 'tw-text-[#231f20]' : ''
                } `"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgLow}; opacity: 0.5`"
                ></div>
                {{ item.lowNumber }}
              </div>
              <div
                v-if="item.mediumNumber || !item.isReduction"
                class="tw-flex tw-gap-[6px] tw-items-center"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgMedium}; opacity: 0.5`"
                ></div>
                {{ item.mediumNumber }}
              </div>
              <div
                v-if="item.highNumber || !item.isReduction"
                class="tw-flex tw-gap-[6px] tw-items-center"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgHigh}; opacity: 0.5`"
                ></div>
                {{ item.highNumber }}
              </div>
              <div
                v-if="
                  item.relaModerateNumber ||
                  (!item.isReduction && item.isRelative)
                "
                class="tw-flex tw-gap-[6px] tw-items-center"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaModerate}; opacity: 0.3`"
                ></div>
                {{ item.relaModerateNumber }}
              </div>
              <div
                v-if="
                  item.relaHighNumber || (!item.isReduction && item.isRelative)
                "
                class="tw-flex tw-gap-[6px] tw-items-center"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaHigh}; opacity: 0.6`"
                ></div>
                {{ item.relaHighNumber }}
              </div>
              <div
                v-if="
                  item.relaHighestNumber ||
                  (!item.isReduction && item.isRelative)
                "
                class="tw-flex tw-gap-[6px] tw-items-center"
              >
                <div
                  :style="`border-radius: 100%; width: 7px; height: 7px; background-color:${item.bgRelaHighest};`"
                ></div>
                {{ item.relaHighestNumber }}
              </div>
              <div
                v-if="!item?.isRelativeRisk && item.isReduction"
                class="tw-flex tw-items-center tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-justify-center"
                :style="`background-color:${item.bgText}; color:${item.colorText}; border-radius:4px`"
              >
                {{ item.textStatus }}
              </div>
              <StatusBadge
                v-if="item?.isRelativeRisk"
                :value="
                  getTagRelativeRisk(
                    item.value,
                    isActionTable ? dataPercentile : dataPercentileTemplate,
                  ) ?? ''
                "
                class="tw-w-fit"
              />
            </div>
          </div>
          <div v-if="!item.isReduction" class="tw-flex tw-opacity-50">
            <div
              :style="`height: 7px; flex:${item.lowNumber}; background-color:${
                item.bgLow
              }; border-top-left-radius:10px ; border-bottom-left-radius:10px;
                ${getBorder('low', item)}
              `"
            ></div>
            <div
              :style="`height: 7px; flex:${
                item.mediumNumber
              }; background-color:${item.bgMedium}; ${getBorder(
                'medium',
                item,
              )} `"
            ></div>
            <div
              :style="`height: 7px; flex:${item.highNumber}; background-color:${
                item.bgHigh
              }; ${getBorder(
                'high',
                item,
              )}; border-top-right-radius:10px ; border-bottom-right-radius:10px`"
            ></div>
            <div
              :style="`height: 7px; flex:${
                item.relaModerateNumber
              }; background-color:${item.bgRelaModerate}; opacity: 0.3;
              border-top-left-radius:10px ; border-bottom-left-radius:10px;
              ${
                !item.relaHighNumber && !item.relaHighestNumber
                  ? 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
                  : 'border-top-left-radius:10px ; border-bottom-left-radius:10px;'
              }`"
            ></div>
            <div
              :style="`height: 7px; flex:${
                item.relaHighNumber
              }; background-color:${item.bgRelaHigh}; opacity: 0.6;
              ${
                !item.relaModerateNumber || !item.relaHighestNumber
                  ? 'border-radius:10px;'
                  : !item.relaModerateNumber
                    ? 'border-top-left-radius:10px ; border-bottom-left-radius:10px'
                    : !item.relaHighestNumber
                      ? 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
                      : ''
              }`"
            ></div>
            <div
              :style="`height: 7px; flex:${
                item.relaHighestNumber
              }; background-color:${item.bgRelaHighest}; opacity: 1; 
              border-top-right-radius:10px ; border-bottom-right-radius:10px; ${
                !item.relaModerateNumber && !item.relaHighNumber
                  ? 'border-top-left-radius:10px ; border-bottom-left-radius:10px'
                  : 'border-top-right-radius:10px ; border-bottom-right-radius:10px'
              }`"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-if="!score"
        class="dummy tw-px-[20px] tw-text-[13px] tw-font-[400] tw-text-[#211F58]"
      >
        <div
          :class="`tw-text-[#211F58] tw-font-[Poppins] tw-leading-[135%] tw-text-center title`"
        >
          {{
            getComponentUiText("app-assess-recommendations-risk-no-data-risk-1")
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, Ref } from "vue";
import { getComponentUiText, getTagRelativeRisk } from "@/utils/utilities";
import { computed } from "vue";
import store from "@/store";
import StatusBadge from "../common/setting/statusBadge.vue";

const props = defineProps({
  score: {
    type: Boolean,
    default: true,
  },
  listRisk: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  typeStyle: {
    type: Boolean,
    default: false,
  },
  isActionTable: {
    type: [Boolean, Number],
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const listRiskRef = computed(() => {
  return props.listRisk;
});
const dataPercentile: Ref<any> = computed(() => {
  return store.state.Recommend.recommendPercentileChecklistGroupMetrics;
});

const dataPercentileTemplate: Ref<any> = computed(() => {
  return store.state.Recommend.percentileChecklistGroupTemplateMetrics;
});

const getBorder = (type: any, item: any) => {
  let style = "";
  switch (type) {
    case "low":
      if (!item.mediumNumber && !item.highNumber) {
        style +=
          "border-top-right-radius:10px ; border-bottom-right-radius:10px;";
      }
      break;
    case "medium":
      if (!item.highNumber) {
        style +=
          "border-top-right-radius:10px ; border-bottom-right-radius:10px;";
      }
      if (!item.lowNumber) {
        style +=
          "border-top-left-radius:10px ; border-bottom-left-radius:10px;";
      }
      break;
    case "high":
      if (!item.mediumNumber && !item.lowNumber) {
        style +=
          "border-top-left-radius:10px ; border-bottom-left-radius:10px;";
      }
      break;
  }
  return style;
};
</script>
<style lang="scss" scoped>
.risk__header {
  position: relative;
}
.risk__header__icon {
  position: absolute;
  right: 0px;
  top: -10px;
}
.title-note {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}

.dummy {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(12px);
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-top: 1px solid #eff0f1;
  padding-top: 10px;
  text-align: center;
  display: flex;
  align-items: center;
}
</style>
